import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Copy",
  "use": "Copy-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"Copy\"><path d=\"M18 15V8c0-2-.865-3-3-3h-5c-1.266 0-1.266-2 0-2h6.495C18.103 3 20 4.46 20 6.46V15c0 1.446-2 1.446-2 0ZM6 7h8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2Zm1 2a1 1 0 1 0 0 2h6a1 1 0 0 0 0-2H7Zm0 4a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2H7Zm0 4a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2H7Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol